import React, { useState } from "react";

import moment from "moment";
import { Form, Upload, Spin, App } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import Icon from "../../Icon";
import { uploadFile } from "../../../pages/api/modules/User";

const antIcon = (
  <LoadingOutlined style={{ fontSize: 20, color: "white" }} spin />
);

const UIImageUploder = ({
  label,
  required,
  rules,
  onChange = () => {},
  validateStatus,
  hasFeedback,
  help,
  disabled,
  name,
  defaultValue,
  placeholder = "",
}) => {
  const [imageURL, setImageUrl] = useState(defaultValue);
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();
  const onUpload = async ({ fileList }) => {
    setLoading(true);
    const url = URL.createObjectURL(fileList[0]?.originFileObj);
    if (fileList.length > 0) {
      const formData = new FormData();
      formData.append("file", fileList[0]?.originFileObj);
      const res = await uploadFile(formData);
      if (res?.Status === 1) {
        setImageUrl(url);
        setLoading(false);

        onChange(res?.Data?.Files?.FileName);
      } else {
        message.error("Something went wrong");
      }
    }
    setLoading(false);
  };

  return (
    <Form.Item
      label={label}
      name={name}
      required={required}
      rules={rules}
      hasFeedback={hasFeedback}
      help={help}
      validateStatus={validateStatus}
      initialValue={defaultValue ? moment(defaultValue) : ""}
    >
      {imageURL && (
        <>
          <div
            style={{
              height: 200,
              width: 200,
              marginBottom: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                cursor: "pointer",
                marginBottom: 10,
              }}
            >
              <Icon
                onClick={() => {
                  onChange();
                  setImageUrl();
                }}
                color="#f66363"
                size={16}
                Icon={faXmark}
              />
            </div>

            <img
              style={{ backgroundColor: "white" }}
              alt="Image"
              width={200}
              height={200}
              src={imageURL}
            />
          </div>
        </>
      )}
      <Upload onChange={onUpload} maxCount={1} showUploadList={false}>
        {imageURL ? null : (
          <div
            style={{
              height: 200,
              width: 200,
              borderRadius: 8,
              background: "#dae3ed",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              marginBottom: 20,
              position: "relative",
              fontSize: 20,
            }}
          >
            {loading ? <Spin indicator={antIcon} /> : "+ Upload"}
          </div>
        )}
      </Upload>
    </Form.Item>
  );
};

export default UIImageUploder;
